var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkeye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0559 2.57102C22.2686 4.1463 23.9702 6.33396 24.9504 8.86364C25.0166 9.04632 25.0166 9.24636 24.9504 9.42905C23.9702 11.9587 22.2686 14.1464 20.0559 15.7217C17.8432 17.2969 15.2163 18.1908 12.5 18.2927C9.78369 18.1908 7.15684 17.2969 4.94412 15.7217C2.7314 14.1464 1.02981 11.9587 0.0496469 9.42905C-0.016549 9.24636 -0.016549 9.04632 0.0496469 8.86364C1.02981 6.33396 2.7314 4.1463 4.94412 2.57102C7.15684 0.99575 9.78369 0.101918 12.5 0C15.2163 0.101918 17.8432 0.99575 20.0559 2.57102ZM9.49058 13.6401C10.3814 14.234 11.4287 14.551 12.5 14.551C13.936 14.5488 15.3125 13.9787 16.3278 12.9656C17.3432 11.9525 17.9146 10.5791 17.9168 9.14634C17.9168 8.0774 17.5991 7.03247 17.0039 6.14368C16.4087 5.25488 15.5627 4.56216 14.5729 4.15309C13.5831 3.74402 12.494 3.63699 11.4432 3.84553C10.3925 4.05407 9.42729 4.56882 8.66973 5.32467C7.91217 6.08053 7.39627 7.04354 7.18726 8.09194C6.97825 9.14035 7.08552 10.227 7.49551 11.2146C7.9055 12.2022 8.59978 13.0463 9.49058 13.6401ZM15.623 9.14653C15.623 10.8303 14.2239 12.1953 12.498 12.1953C10.7721 12.1953 9.37299 10.8303 9.37299 9.14653C9.37299 7.46273 10.7721 6.09775 12.498 6.09775C14.2239 6.09775 15.623 7.46273 15.623 9.14653Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkeye);
export default __webpack_public_path__ + "static/media/pinkeye.7d438fa79c2f2f74fb8ec3619cc56804.svg";
export { ForwardRef as ReactComponent };